<div class="row justify-content-center  mt-5 pt-5" >

  <div class="card " style="width: 600px;height: 400px">
    <div class="card-body">
      <div class="row justify-content-between">

        <div class="aml-text ">
          <img
            src="../../assets/images/aml-logo.png"
            class="logo"
            style="width: 110px;"
          />
        </div>

        <div class="aml-text ">
          <img
            src="../../assets/images/bkash_logo.png"
            class="logo"
            style="width: 65px;height: 20px"
          />
        </div>

      </div>

      <div class="row justify-content-center mt-5">
        <p style="font-size: 20px;color: #E2136E">Forgot Password</p>
      </div>

      <div class="row justify-content-center">
        <p style="font-size: 16px" class="text-muted">Please Enter Your Registered LoginId and Email Address</p>
      </div>

      <div class="row justify-content-center pt-3">

        <div class="form-group  pt-2 ">
          <i class="fa fa-user fa-2x icon mr-5"></i>
        </div>
        <div>
          <input
            [(ngModel)]="loginId"
            type="user"
            class="form-control user"
            name="user"
            placeholder="loginId"
          />
        </div>

      </div>


      <div class="row justify-content-center">

        <div class="form-group  pt-2 ">
          <i class="fa fa-envelope fa-2x icon mr-5"></i>
        </div>
        <div>
          <input
            [(ngModel)]="email"
            type="user"
            class="form-control user"
            name="user"
            placeholder="Email"
          />
        </div>

      </div>

      <div class="row justify-content-center mt-5">

        <div class="ml-2 ">
          <button class="btn btn-light pl-5 pr-5" [routerLink]="['/login']">
            Go to Login
          </button>
        </div>


        <div class="ml-2 ">
          <button class="btn btn-light" (click)="onSubmit()">
            Send Password to Mail
          </button>
        </div>


      </div>




    </div>
  </div>

</div>



